<script lang="ts">
  import AddCardModal from "./AddCardModal.svelte";
  import CardsView from "./CardsView.svelte";
  import { Button, Hor, Spacer, Toast, WithResource } from "$components";
  import { type Readable } from "svelte/store";
  import api, { fromApi } from "$shared/lib/api-parkito2.svelte.ts";
  import type { PaymentCard } from "$apis/parkito2/index.ts";

  const {
    debtorId,
    showAddButton = true,
    onCardsFetched,
  }: {
    debtorId: Readable<string>;
    showAddButton?: boolean;
    onCardsFetched?: (cards: PaymentCard[]) => void;
  } = $props();

  const fetchCards = fromApi((debtorId: string) =>
    api.debtorGetCards({ path: { id: debtorId } })
  );
  $fetchCards.onOk((c) => onCardsFetched && onCardsFetched(c));
  debtorId.subscribe((debId) => $fetchCards.load(debId));

  let addCardModal: AddCardModal | undefined = $state();
  let isOpening = $state(false);
  async function openAddCard() {
    isOpening = true;
    await addCardModal?.openDialog?.();
    isOpening = false;
  }

  function cardAdded() {
    Toast.success("Nytt kort tillagd");
    $fetchCards.reload($debtorId);
    addCardModal!.closeDialog();
  }

  async function handleRemoveCard(cardId: string) {
    await api.debtorDeleteCard({ path: { cardId, debtorId: $debtorId } });
    await $fetchCards.reload($debtorId);
  }

  async function handleSetDefault(cardId: string) {
    await api.debtorSetDefaultCard({
      path: { cardId, debtorId: $debtorId },
    });
    await $fetchCards.reload($debtorId);
  }
</script>

<WithResource api={fetchCards}>
  {#snippet child(cards)}
    <CardsView
      {cards}
      onSetDefault={handleSetDefault}
      onRemoveCard={handleRemoveCard}
    />
  {/snippet}
</WithResource>

{#if showAddButton}
  <Hor>
    <Spacer />
    <Button
      type="ghost"
      full={false}
      text="Lägg till kort"
      loading={isOpening}
      onClick={openAddCard}
    />
  </Hor>
  <AddCardModal
    bind:this={addCardModal}
    debtorId={$debtorId}
    onCardAdded={cardAdded}
  ></AddCardModal>
{/if}
